import { GitPullRequestCreate, PlusSquare, Trash } from 'lucide-angular';
import { MenuAction } from '@shared/interfaces/header/menu-action';

export const connectionpointSearchActionMenu: MenuAction[] = [
  {
    id: 'create',
    title: 'action.add',
    breaker: false,
    icon: PlusSquare
  },
  {
    id: 'createMeteringPoint',
    title: 'connectionPoint.create.relatedMeteringPoint',
    icon: GitPullRequestCreate,
  },
  {
    id: 'close',
    title: 'action.close',
    icon: Trash,
    iconColor: 'text-red-500',
    disabled: true,
  },
];
